import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import SweetAlertService from "../../../services/SweetAlertService";
import { contentAsDraft, contentAsPublished, getRequiredErrorMessage } from "../Shared/Constants/AdminModuleConstants";
import { Editor, EditorChangeEvent, EditorTools } from "@progress/kendo-react-editor";
import MyColorTool from "./MyColorTool";
import FaqService from "../../members/Services/FaqService";
const {
    Bold, Italic, Underline, Strikethrough, Subscript, Superscript, AlignLeft, AlignCenter, AlignRight,
    AlignJustify, Indent, Outdent, OrderedList, UnorderedList, Undo,
    Redo, FontSize, FontName, FormatBlock, Link, Unlink, ViewHtml
} = EditorTools;

export const FaqDetails = () => {
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [description, setDescription] = useState("");
    const [faqId, setfaqId] = useState();
    const [isFaqPublished, setIsFaqPublished] = useState(false);

    useEffect(() => {
        getFaq();
    }, []);

    const getFaq = () => {
        FaqService.getFaq().then((response: any) => {
            setValue("heading", response.data.heading);
            setValue("description", response.data.description);
            setDescription(response.data.description);
            setIsFaqPublished(response.data.isPublished)
            setfaqId(response.data.id)
        }).catch(() => {
            SweetAlertService.error("Error", `Something went wrong while getting faq`);
        })
    }

    const onCancelClick = () => {
        getFaq();
    };

    const onFaqSubmitDraft = (data: any) => {
        data.heading = data.heading;
        data.description = description;
        data.isPublished = false;
        data.id = faqId;
        updateFaq(data.id, data);
    };

    const onFaqSubmitPublish = (data: any) => {
        data.heading = data.heading;
        data.description = description;
        data.isPublished = true;
        data.id = faqId;
        updateFaq(data.id, data);
    };

    const updateFaq = (id: number, data: any) => {
        FaqService.updateFaq(id, data).then((response) => {
            if (response) {
                getFaq();
                if (data.isPublished) {
                    SweetAlertService.success("Success", "Faq has been successfully published");
                } else {
                    SweetAlertService.success("Success", "Faq has been saved as a draft");
                }
            }
        }).catch(() => {
            SweetAlertService.error("Error", "Something went wrong while updating the faq");
        })
    }
    const onDescriptionChange = (event: EditorChangeEvent) => {
        setDescription(event.html);
    }

    return (
        <div className="hero-banner hero-banner--background hero-banner--subpage">
            <div className="container mt-2">
                <div className="m-2">
                    <div className="hero-banner__image-container">
                        <div className="card card-default">
                            <div className="card-body">
                                <form>
                                    <div className="form-group">
                                        <label className="col-sm control-label mb-1 ps-0">Heading</label>
                                        <div className="col-sm-12 ps-0 pe-0">
                                            <input type="text" className="form-control"
                                                {...register("heading", {
                                                    required: getRequiredErrorMessage("Heading")
                                                })}
                                            />
                                            {errors.heading && (
                                                <span className="help-block m-b-none text-danger field-validation-valid">{"The Heading field is required"}</span>
                                            )}
                                        </div>
                                    </div>
                                    <br />
                                    <div className="form-group">
                                        <label className="col-sm control-label mb-1 ps-0">Main content</label>
                                        <div className="col-sm-12 ps-0 pe-0">
                                            <Editor
                                                tools={[
                                                    [Bold, Italic, Underline, Strikethrough],
                                                    [Subscript, Superscript],
                                                    [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                                    [Indent, Outdent],
                                                    [OrderedList, UnorderedList],
                                                    FontSize,
                                                    FontName,
                                                    FormatBlock,
                                                    [Undo, Redo],
                                                    [Link, Unlink, ViewHtml],
                                                    [MyColorTool]
                                                ]}
                                                contentStyle={{
                                                    height: 300,
                                                }}
                                                value={description}
                                                onChange={onDescriptionChange}
                                            />
                                        </div>
                                    </div>
                                    <br />
                                    <div className="form-group row">
                                        <div className=" col-sm-offset">
                                            <button className="btn btn-primary" onClick={handleSubmit(onFaqSubmitDraft)}>
                                                Save as draft
                                            </button>
                                            <button className="btn btn-primary ms-1" onClick={handleSubmit(onFaqSubmitPublish)}>
                                                Publish
                                            </button>
                                            <button className="btn btn-secondary float-end" onClick={handleSubmit(onCancelClick)}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                    <br />
                                    <div className=" col-sm-offset my-3 ">
                                        <strong>Status:</strong> {isFaqPublished ? contentAsPublished : contentAsDraft}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}